import { atom } from 'jotai'
import { Contact } from '../services/api'
import { countsAsOutreach } from '../constants/networking'

export const contactsAtom = atom<Contact[]>([])
export const contactsLoadingAtom = atom(true)
export const selectedContactAtom = atom<Contact | null>(null)

// Derived: contacts grouped by company
export const contactsByCompanyAtom = atom((get) => {
  const contacts = get(contactsAtom)
  const grouped: Record<string, Contact[]> = {}
  contacts.forEach((c) => {
    const company = c.company || 'Other'
    if (!grouped[company]) grouped[company] = []
    grouped[company].push(c)
  })
  return grouped
})

// Derived: contact stats
export const contactStatsAtom = atom((get) => {
  const contacts = get(contactsAtom)
  return {
    total: contacts.length,
    contacted: contacts.filter((c) => countsAsOutreach(c.status)).length,
    priority: contacts.filter((c) => c.isPriority).length,
  }
})
